import { USER_LEVEL_KEY } from '~/api/interface';
import { USER_ADMIN, USER_VERIFY_STATUS } from '~/constants';
import { PURE_HOST } from '~/utils/constant';

// 企业版(标准、旗舰、入门、试用）
const TeamRightTypes = [
  USER_LEVEL_KEY.ORG_STANDARD,
  USER_LEVEL_KEY.ORG_FLAGSHIP,
  USER_LEVEL_KEY.TEAM_LIGHT,
  USER_LEVEL_KEY.TEAM_TASTE,
];

export function useDetector() {
  const userInfo = useUserInfo();
  const route = useRoute();

  // 判断当前是否是团队账号
  const isTeamRight = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return TeamRightTypes.includes(userInfo.value.rights_type);
  });

  // 判断当前是否是体验版
  const isRightTaste = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return userInfo.value.rights_type === USER_LEVEL_KEY.TASTE;
  });

  const isRightPersonal = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return [USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
      userInfo.value.rights_type
    );
  });

  // 是否是账号管理员
  const isAdmin = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return userInfo.value.permission !== USER_ADMIN.NORMAL;
  });

  // 是否认证
  const isVerified = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return userInfo.value.identify_info?.status === USER_VERIFY_STATUS.SUCCESS;
  });

  // 是否是首页相关路由
  const isHome = computed(() => route.name === 'home' || route.path.startsWith('/home'));

  // 是否可以升级
  const isUpgradable = computed(() => {
    if (!userInfo.value) {
      return false;
    }
    return [USER_LEVEL_KEY.PERSONAL_LITE].includes(userInfo.value.rights_type);
  });

  // 是否是纯净版
  const isPure = computed(() => {
    const url = useRequestURL();
    return PURE_HOST.some(item => item.test(url.host));
  });

  return {
    isTeamRight,
    isRightTaste,
    isAdmin,
    isVerified,
    isHome,
    isRightPersonal,
    isUpgradable,
    isPure,
  };
}
